/**
 * Versión del documento de T&C del Plan MS2 que muestra `TyCMs2Modal`.
 * Tiene que coincidir con `TYC_MS2_VERSION_ACTUAL` del backend
 * (`server/src/modules/portal/tyc-ms2.constants.ts`). Si cambian los T&C:
 *   1. Actualizar el texto del modal (TyCMs2Modal.tsx).
 *   2. Bumpear esta constante y la del backend a la misma versión nueva.
 *   3. Los titulares que ya aceptaron quedan vinculados a la versión vieja.
 */
export const TYC_MS2_VERSION_ACTUAL = '2026-05-23-osffeseg-v1';
